export default "__VITE_ASSET___7QBmwiV__"